import { Link } from 'react-router-dom'

type DrilldownLinkProps = {
  label: string
  active: boolean
  to: string
}

export const DrilldownLink = ({ label, active, to }: DrilldownLinkProps) => {
  if (active) {
    return label
  }

  return (
    <Link
      to={to}
      className="cursor-pointer text-left text-primary underline hover:text-primary-dark after:absolute after:inset-0"
      onClick={(event) => {
        event.stopPropagation()
      }}
    >
      {label}
    </Link>
  )
}
